import { FullPhysicianResponse, PermissionBit } from "../../../api";
import { AccessRules } from "../../../constants/roles";
import { DataModel } from "../../../models/data-model";

export class PatientPhysicians extends DataModel<FullPhysicianResponse> {
  readonly idAttr = "uuid";

  constructor(
    data: FullPhysicianResponse[],
    permissions: PermissionBit[],
    userUUID: string,
  ) {
    super(data, permissions, userUUID);

    this.access = {
      editRules: { medical: AccessRules.none, monitoring: AccessRules.none },
      deleteRules: { medical: AccessRules.none, monitoring: AccessRules.none },
      historyRequiresMonitoring: false,
    };
  }
}
